<template lang="pug">
  .header
    .header-logo
      .header-link
        router-link(to="/")



    ul.nav
      li.nav-item
        router-link(to="/") Work
      li.nav-item
        router-link(to="/about") About


</template>

<script>
export default {};
</script>

<style>
.header {
  height: 140px;
  line-height: 180px;
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
}
.header-logo {
  width: 330px;
  background-image: url("/img/logo.png");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  margin: 0 15px 0 46px;
}
.header-link,
.header-link a {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.nav {
  text-align: left;
  display: flex;
  margin: 0 20px 0 0;
}
.nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  text-align: center;
}
.nav a.router-link-exact-active {
  color: #42b983;
}
.nav-item {
  text-align: center;
}
</style>
